import { Component, OnInit, ChangeDetectionStrategy, Input, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ReCaptchaV3Service } from 'ng-recaptcha';
import { GetPasswordResetUrl } from 'src/app/models/api/requests/getPasswordResetUrl/getPasswordResetRequest';
import { NetworkService } from 'src/app/services/network.service';

@Component({
  selector: 'fortgot-password',
  templateUrl: './fortgot-password.component.html',
  styleUrls: ['./fortgot-password.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FortgotPasswordComponent implements OnInit {
  @Input() visibleCard: string;
  @Output() visibleCardChange: EventEmitter<string> = new EventEmitter<string>();
  loginForm: FormGroup;

  constructor(private fb: FormBuilder, private recaptchaV3Service: ReCaptchaV3Service, private networkService: NetworkService,
    private snackBar: MatSnackBar) { }

  goBack(){
    this.visibleCard = "LOGIN";
    this.visibleCardChange.emit(this.visibleCard);
  }

  public executeImportantAction(): void {
    this.recaptchaV3Service.execute('importantAction')
      .subscribe((token) => this.handleToken(token));
  }

  private handleToken(token){
    let email: string = this.loginForm.get("email").value;
    let request: GetPasswordResetUrl = new GetPasswordResetUrl(email);
    this.networkService.executeBaseAtlasPostRequest(request).then(()=>{
      this.snackBar.open("E-Mail mit Link zum zurücksetzen des Passwortes wurde verschickt.", undefined, {duration: 5000})
    })
  }

  ngOnInit(): void {
    this.loginForm = this.fb.group({
      email: ['', [Validators.required]]
    }, {})
  }

}
